import { SoapUtils } from '../../../../utils/SoapUtils';
import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IListMessageRequest extends IBaseRequest {
    parent?:            string;
    offset?:            string;
    limit?:             string;
    dateTo?:            string;
    dateFrom?:          string;
    contains?:          string;
    senderPlain?:       string;
    sender?:            string;
    status?:            string;
    printed?:           string;
    newOnly?:           string;
    order?:             string;
    orderBy?:           string;
    fromNode?:          string;
    treeHandle?:        string;
    showInbox?:         string;
    tree?:              string;
    showDeleted?:       string;
    showOutgoing?:      string;
    showSent?:          string;
    showDrafts?:        string;
    showAll?:           string;
    showAllMy?:         string;
    starred?:           string;
    subjectContains?:   string;
    countOnly?:         string;
    filterLastMonths?:  string;
    CONTACT_RELATIONS?: ContactRelations;
    threadId?:          string;
}

export interface ContactRelations {
    CONTACT_RELATION: ContactRelation[];
}

export function toContactRelationsXml(cr: ContactRelations): string {
    var xml = `<CONTACT_RELATIONS>`;
    if(cr.CONTACT_RELATION) {
        cr.CONTACT_RELATION.forEach(function (contactRelation) {
            xml += toContactRelationXml(contactRelation);
        });
    }
    xml += `</CONTACT_RELATIONS>`;
    return xml;
}

export interface ContactRelation {
    type?:       string;
    identifier?: string;
    contact?:    string;
}

export function toContactRelationXml(cr: ContactRelation): string {
    var xml = `<CONTACT_RELATION>`;
    xml += SoapUtils.makeNode(cr.type, 'type');
    xml += SoapUtils.makeNode(cr.identifier, 'identifier');
    xml += SoapUtils.makeNode(cr.contact, 'contact');
    xml += `</CONTACT_RELATION>`;
    return xml;
}

export class ListMessageRequest extends BaseRequest implements IListMessageRequest {

    public parent?: string;
    public offset?: string;
    public limit?: string;
    public dateTo?: string;
    public dateFrom?: string;
    public contains?: string;
    public senderPlain?: string;
    public sender?: string;
    public status?: string;
    public printed?: string;
    public newOnly?: string;
    public order?: string;
    public orderBy?: string;
    public fromNode?: string;
    public treeHandle?: string;
    public showInbox?: string;
    public tree?: string;
    public showDeleted?: string;
    public showOutgoing?: string;
    public showSent?: string;
    public showDrafts?: string;
    public showAll?: string;
    public showAllMy?: string;
    public starred?: string;
    public subjectContains?: string;
    public countOnly?: string;
    public filterLastMonths?: string;
    public CONTACT_RELATIONS?: ContactRelations;
    public threadId?: string;

    constructor(server: string, session: string, otherOptions: any) {
        super(server, session);
        this.parent = otherOptions.parent;
        this.offset = otherOptions.offset;
        this.limit = otherOptions.limit;
        this.dateTo = otherOptions.dateTo;
        this.dateFrom = otherOptions.dateFrom;
        this.contains = otherOptions.contains;
        this.senderPlain = otherOptions.senderPlain;
        this.sender = otherOptions.sender;
        this.status = otherOptions.status;
        this.printed = otherOptions.printed;
        this.newOnly = otherOptions.newOnly;
        this.order = otherOptions.order;
        this.orderBy = otherOptions.orderBy;
        this.fromNode = otherOptions.fromNode;
        this.treeHandle = otherOptions.treeHandle;
        this.showInbox = otherOptions.showInbox;
        this.tree = otherOptions.tree;
        this.showDeleted = otherOptions.showDeleted;
        this.showOutgoing = otherOptions.showOutgoing;
        this.showSent = otherOptions.showSent;
        this.showDrafts = otherOptions.showDrafts;
        this.showAll = otherOptions.showAll;
        this.showAllMy = otherOptions.showAllMy;
        this.starred = otherOptions.starred;
        this.subjectContains = otherOptions.subjectContains;
        this.countOnly = otherOptions.countOnly;
        this.filterLastMonths = otherOptions.filterLastMonths;
        this.threadId = otherOptions.threadId;
        this.CONTACT_RELATIONS = otherOptions.CONTACT_RELATIONS;
    }

    public toXml(): string {
        var parameters: string = super.toXml();

        parameters += this.makeNode(this.parent, 'parent');
        parameters += this.makeNode(this.offset, 'offset');
        parameters += this.makeNode(this.limit, 'limit');
        parameters += this.makeNode(this.dateTo, 'dateTo');
        parameters += this.makeNode(this.dateFrom, 'dateFrom');
        parameters += this.makeNode(this.contains, 'contains');
        parameters += this.makeNode(this.senderPlain, 'senderPlain');
        parameters += this.makeNode(this.sender, 'sender');
        parameters += this.makeNode(this.status, 'status');
        parameters += this.makeNode(this.printed, 'printed');
        parameters += this.makeNode(this.newOnly, 'newOnly');
        parameters += this.makeNode(this.order, 'order');
        parameters += this.makeNode(this.orderBy, 'orderBy');
        parameters += this.makeNode(this.fromNode, 'fromNode');
        parameters += this.makeNode(this.treeHandle, 'treeHandle');
        parameters += this.makeNode(this.showInbox, 'showInbox');
        parameters += this.makeNode(this.tree, 'tree');
        parameters += this.makeNode(this.showDeleted, 'showDeleted');
        parameters += this.makeNode(this.showOutgoing, 'showOutgoing');
        parameters += this.makeNode(this.showSent, 'showSent');
        parameters += this.makeNode(this.showDrafts, 'showDrafts');
        parameters += this.makeNode(this.showAll, 'showAll');
        parameters += this.makeNode(this.showAllMy, 'showAllMy');
        parameters += this.makeNode(this.starred, 'starred');
        parameters += this.makeNode(this.subjectContains, 'subjectContains');
        parameters += this.makeNode(this.countOnly, 'countOnly');
        parameters += this.makeNode(this.filterLastMonths, 'filterLastMonths');
        parameters += this.makeNode(this.threadId, 'threadId');
        if(this.CONTACT_RELATIONS) parameters += toContactRelationsXml(this.CONTACT_RELATIONS);
        
        return super.wrapperXml('ListMessage', parameters);
    }
}
